<template>
  <div class="insight-page container-fluid">
    <div class="insight-page-titles">
      <h1
        v-for="t in insightPageTitles"
        :key="t.link"
        :class="['insight-page-title', {'current-title': isCurrentTitle(t.link)}]"
      >
        <router-link :to="t.link">{{ t.name }}</router-link>
      </h1>
    </div>
    <div class="insight-page-contents">
      <keep-alive>
        <transition name="fade" mode="out-in">
          <router-view class="content"></router-view>
        </transition>
      </keep-alive>
    </div>
    <GetFreeApiModal></GetFreeApiModal>
  </div>
</template>

<script>
import GetFreeApiModal from "@/components/modal/get-free-api-modal";

export default {
  name: "InsightPage",

  computed: {},

  components: {
    GetFreeApiModal
  },

  data() {
    return {
      insightPageTitles: [
        { name: "News", link: "/insight/news" },
        { name: "Company", link: "/insight/company" }
        // { name: "Market Indices", link: "/insight/market_indices" },
        // {
        //   name: "Futures & Commodities",
        //   link: "/insight/futures_and_commodities"
        // }
      ]
    };
  },

  mounted() {
    console.log("*[insight-page] mounted() link is: ", this.$route.path);
    let interval = setInterval(() => {
      if (drift.api) {
        drift.api.widget.hide();
        clearInterval(interval);
      } else {
        console.log("not found yet");
      }
    }, 200);
  },

  beforeDestroy() {
    drift.api.widget.show();
  },

  methods: {
    isCurrentTitle(link) {
      const currentPath = this.$route.path;
      // console.log("isCurrentTitle() path is: ", currentPath.split("/")[2]);
      // console.log("isCurrentTitle() link is: ", link.split("/")[2]);
      return currentPath.split("/")[2] === link.split("/")[2];
    }
  }
};
</script>


<style scoped>
.insight-page-titles {
  margin: 1rem 0;
  border-bottom: 1px solid #d8d8d8;
}

.insight-page-titles > h1 {
  display: inline-block;
  font-size: 0.8rem;
  line-height: initial;
  margin: 0px 0.5rem;
  padding: 0.5rem 0;
  letter-spacing: -1px;
}

.insight-page-titles > h1 > a {
  color: black;
}

.insight-page-titles > h1 > a:hover {
  text-decoration: none;
}

.current-title {
  font-weight: bold;
  border-bottom: 1px solid #4a4a4a;
}

@media (min-width: 768px) {
  .insight-page-titles > h1 {
    font-size: 1rem;
    margin: 0px 0.8rem;
    letter-spacing: 0;
  }
}

@media (min-width: 992px) {
  .insight-page-titles > h1 {
    font-size: 1rem;
    margin: 0px 1rem;
  }
}

@media (min-width: 1200px) {
  .insight-page-titles > h1 {
    font-size: 1rem;
    margin: 0px 1.2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insight-pages/insight-page.vue